import SortableElement from './sortable-element'
import PlaceHolder from './form-place-holder'
import BaseFormElements from './form-elements'

const {
  Button,
  HtmlCode,
  TypeForm,
  Header,
  Paragraph,
  Label,
  LineBreak,
  TextInput,
  EmailInput,
  NumberInput,
  TextArea,
  Dropdown,
  Checkboxes,
  DatePicker,
  RadioButtons,
  Image,
  Rating,
  Tags,
  Signature,
  HyperLink,
  ButtonLink,
  Download,
  Camera,
  Range,
  MockupForm
} = BaseFormElements

const FormElements = {}

FormElements.Header = SortableElement(Header)
FormElements.Button = SortableElement(Button)
FormElements.HtmlCode = SortableElement(HtmlCode)
FormElements.TypeForm = SortableElement(TypeForm)
FormElements.Paragraph = SortableElement(Paragraph)
FormElements.Label = SortableElement(Label)
FormElements.LineBreak = SortableElement(LineBreak)
FormElements.TextInput = SortableElement(TextInput)
FormElements.EmailInput = SortableElement(EmailInput)
FormElements.NumberInput = SortableElement(NumberInput)
FormElements.TextArea = SortableElement(TextArea)
FormElements.Dropdown = SortableElement(Dropdown)
FormElements.Signature = SortableElement(Signature)
FormElements.Checkboxes = SortableElement(Checkboxes)
FormElements.DatePicker = SortableElement(DatePicker)
FormElements.RadioButtons = SortableElement(RadioButtons)
FormElements.Image = SortableElement(Image)
FormElements.Rating = SortableElement(Rating)
FormElements.Tags = SortableElement(Tags)
FormElements.HyperLink = SortableElement(HyperLink)
FormElements.ButtonLink = SortableElement(ButtonLink)
FormElements.Download = SortableElement(Download)
FormElements.Camera = SortableElement(Camera)
FormElements.Range = SortableElement(Range)
FormElements.PlaceHolder = SortableElement(PlaceHolder)
FormElements.MockupForm = SortableElement(MockupForm)

export default FormElements
